'use strict';

// import services here:
import { activityService } from './activity.service';
import { adminService } from './admin.service';
import { configService } from './config.service';
import { httpService } from './http.service';
import { loggingService } from './logging.service';
import { workflowService } from './workflow.service';
import { anywhereService } from './anywhere.service';
import { modelViewService } from './modelView.service';

export default function(app) {

    app
        // register services here
        .factory('activityService', activityService)
        .factory('adminService', adminService)
        .factory('configService', configService)
        .factory('httpService', httpService)
        .factory('loggingService', loggingService)
        .factory('workflowService', workflowService)
        .factory('anywhereService', anywhereService)
        .factory('modelViewService', modelViewService);
}